import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=9d9f9cae&scoped=true&"
import script from "./CustomSwitch.vue?vue&type=script&lang=js&"
export * from "./CustomSwitch.vue?vue&type=script&lang=js&"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=9d9f9cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9f9cae",
  null
  
)

export default component.exports